import React from "react";
import "./Button.css";

const applyColors = (event, color, bgColor) => {
  const el = event.currentTarget;
  el.style.color = color;
  el.style.backgroundColor = bgColor;
};

// variant="outline" : bouton secondaire (contour), plein au survol.
// Par défaut : bouton principal plein, qui se soulève au survol (Button.css).
export default function Button({
  text,
  className,
  href,
  newTab,
  theme,
  variant,
}) {
  const outline = variant === "outline";
  const rest = outline
    ? { color: theme.text, backgroundColor: "transparent" }
    : { color: theme.body, backgroundColor: theme.text };
  const hover = outline
    ? { color: theme.body, backgroundColor: theme.text }
    : rest;

  return (
    <div className={className}>
      <a
        className={outline ? "main-button main-button--outline" : "main-button"}
        href={href}
        target={newTab ? "_blank" : undefined}
        rel={newTab ? "noopener noreferrer" : undefined}
        style={{ ...rest, border: `solid 1px ${theme.text}` }}
        onMouseEnter={(event) =>
          applyColors(event, hover.color, hover.backgroundColor)
        }
        onMouseLeave={(event) =>
          applyColors(event, rest.color, rest.backgroundColor)
        }
      >
        {text}
      </a>
    </div>
  );
}
